import React, { useState } from "react";
import styles from "../styles/Msmes.module.css";
import Header from "../components/Header";
import pic from "../assets/msmes.JPG";
import payment from "../assets/terminal.JPG";
import view from "../assets/ms.JPG";
import imag from "../assets/remit.jpg";
import h from "../assets/MERCHANT.jpg";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";

const Msmes = () => {
  const [activeButton, setActiveButton] = useState("Payment in Store");

  const getContent = (buttonText) => {
    switch (buttonText) {
      case "Payment on the go":
        return (
          <>
            <h3 className={styles.sideTextHeading}>Mobile POS Solutions</h3>
            <p className={styles.sideTextParagraph}>
              <span className={styles.icon}>✦</span> Enable staff to accept
              payments anywhere{" "}
              <span className={styles.mobileBreaks}>
                <br />
              </span>{" "}
              in the store, improving customer experience.
            </p>
            <h3 className={styles.sideTextHeading}>Contactless Payments</h3>
            <p className={styles.sideTextParagraph}>
              <span className={styles.icon}>✦</span> Support for mobile wallets,
              and tap-to-pay solutions.
            </p>
          </>
        );

      case "Self Service":
        return (
          <>
            <h3 className={styles.sideTextHeading}>Self-Checkout Kiosks</h3>
            <p className={styles.sideTextParagraph}>
              <span className={styles.icon}>✦</span> Allow customers to scan and
              pay for their items independently.
            </p>
            <h3 className={styles.sideTextHeading}>
              Automated In-Store Ordering
            </h3>
            <p className={styles.sideTextParagraph}>
              <span className={styles.icon}>✦</span> Digital kiosks for in-store
              pickup and pre-ordering.
            </p>
          </>
        );

      case "Commerce Service":
        return (
          <>
            <h3 className={styles.sideTextHeading}>
              Inventory & Store Management
            </h3>
            <p className={styles.sideTextParagraph}>
              <span className={styles.icon}>✦</span> Stock tracking and demand
              forecasting.
            </p>
            <h3 className={styles.sideTextHeading}>
              Loyalty & Rewards Programs
            </h3>
            <p className={styles.sideTextParagraph}>
              <span className={styles.icon}>✦</span> Digital solutions for
              customer engagement, offering discounts and reward points.
            </p>
          </>
        );

      default:
        return (
          <>
            <h3 className={styles.sideTextHeading}>
              Smart POS & Countertop Payments
            </h3>
            <p className={styles.sideTextParagraph}>
              <span className={`${styles.icon} ${styles.green}`}>✦</span>{" "}
              Secure, quick transactions at checkout{" "}
              <span className={styles.mobileBreaks}>
                <br />
              </span>{" "}
              counters to reduce waiting time.
            </p>
            <h3 className={styles.sideTextHeading}>QR Code Payments</h3>
            <p className={styles.sideTextParagraph}>
              <span className={styles.icon}>✦</span> Customers can scan a QR
              code for instant payments, reducing reliance on cash.
            </p>
          </>
        );
    }
  };

  return (
    <div>
      <Header />
      <div className={styles.empoweringSection}>
        <div className={styles.hero}>
          <div className={styles.heroContent}>
            <p className={styles.msmesLabel}>MSMES</p>
            <h1 className={styles.heroTitle}>
              Empowering Small & Medium Businesses With Payment Solution
            </h1>

            <Link to="/ContactUs">
              <button
                style={{ marginLeft: "60px" }}
                className={styles.contactButton}
              >
                Contact Us →
              </button>
            </Link>
          </div>
          <div className={styles.heroImage}>
            <img
              style={{ borderRadius: "40px" }}
              src={pic}
              alt="Payment terminal in a shop"
            />
          </div>
        </div>
      </div>
      <div className={styles.helpingSection}>
        <div className={styles.helpingText}>
          <h2 style={{ fontSize: "24px" }} className={styles.helpingTitle}>
            Digital Payment Tools Built for Small & Medium Businesses
          </h2>
          <p
            style={{ fontSize: "16px" }}
            className={styles.helpingDescription}
          >
    At Arifpay, we’re committed to helping MSMEs unlock the power of seamless, secure, and scalable payment solutions. From local cafés to logistics startups, our platform delivers enterprise-grade technology tailored for small and growing businesses.
          </p>
        </div>
      </div>
   <div className={styles.inside}>
  {/* First Section - Image Left, Text Right */}
  <section className={styles.content}>
    <div
      className={styles.newContent}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        // gap: "40px",
        margin: "0 auto",
        maxWidth: "1200px",
        padding: "20px"
      }}
    >
      <div
        className={styles.solutionImage}
        style={{ position: "relative", display: "inline-block" }}
      >
        <div className={styles.imageContainer}>
          <img
            src={payment}
            alt="feature payment"
            style={{
              width: "450px",
              height: "250px",
              display: "block",
              borderRadius: "15px",
            }}
          />
        </div>
      </div>

      <div
        className={styles.viewText}
        style={{
          fontSize: "12px",
          maxWidth: "600px"
        }}
      >
        <h2 style={{ fontSize: "2.4em", marginBottom: "20px" }}>
       Empowering MSMEs with Smart Payment Tools
        </h2>
        {/* <p className={styles.IdealParagraph} style={{ color: "black", fontSize: "1.5em" }}>Let guests pay how they prefer at the front desk, table, kiosk, or from their phone. Arifpay supports:</p> */}
        <p className={styles.IdealParagraph} style={{ color: "black", fontSize: "1.5em" }}>
         Whether you’re a local vendor or a growing service provider, Arifpay equips you with flexible, mobile-first solutions to receive payments, manage operations, and reach more customers.
        </p>
      </div>
    </div>
  </section>

  {/* Second Section - Text Left, Image Right */}
  <section className={styles.contentReverse}>
    <div
      className={styles.newContentReverse}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "40px",
        margin: "0 auto",
        maxWidth: "1200px",
        padding: "20px",
        flexDirection: "row-reverse"
      }}
    >
      <div
        className={styles.solutionImageReverse}
        style={{ position: "relative", display: "inline-block" }}
      >
        <div className={styles.imageContainerReverse}>
          <img
            src={imag}
            alt="advanced payment"
            style={{
              width: "500px",
              height: "250px",
              display: "block",
              borderRadius: "15px",
              border: "6px solid rgba(143, 188, 143, 0.3)",
            }}
          />
        </div>
      </div>

      <div
        className={styles.viewTextReverse}
        style={{
          fontSize: "12px",
          maxWidth: "500px",
          textAlign: "left"
        }}
      >
        <h2 className={styles.head} style={{ fontSize: "2.4em", marginBottom: "20px" }}>Reinventing the Retail & Service Experience</h2>
        <p style={{ color: "black", fontSize: "1.5em" }}>
          From storefronts to delivery-based models, Arifpay makes every payment smooth and every sale smarter. Our products connect hardware, software, and insights to streamline operations.
        </p>
      </div>
    </div>
  </section>

  {/* Third Section - Image Left, Text Right */}
  <section>
    <div
      className={styles.newContent}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "40px",
        margin: "0 auto",
        maxWidth: "1200px",
        padding: "20px"
      }}
    >
      <div
        className={styles.solutionImage}
        style={{ position: "relative", display: "inline-block" }}
      >
        <div className={styles.imageContainer}>
          <img
            src={view}
            alt="feature payment"
            style={{
              width: "450px",
              height: "250px",
              display: "block",
              borderRadius: "15px",
            }}
          />
        </div>
      </div>

      <div
        className={styles.viewText}
        style={{
          fontSize: "12px",
          maxWidth: "600px"
        }}
      >
        <h2 className={styles.head} style={{ fontSize: "2.4em", marginBottom: "20px" }}> Grow with Loyalty, Promotions & Engagement</h2>
        <p style={{ color: "black", fontSize: "1.5em" }}>
Arifpay helps you keep customers engaged by enabling built-in promotions, loyalty tools, and communication all from the same system.
</p>
      </div>
    </div>
  </section>

  {/* Fourth Section - Text Left, Image Right */}
  <section className={styles.reverse}>
    <div
      className={styles.newContentReverse}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "40px",
        margin: "0 auto",
        maxWidth: "1200px",
        padding: "20px",
        flexDirection: "row-reverse"
      }}
    >
      <div
        className={styles.solutionImageReverse}
        style={{ position: "relative", display: "inline-block" }}
      >
        <div className={styles.imageContainerReverse}>
          <img
            src={h}
            alt="advanced payment"
            style={{
              width: "500px",
              height: "250px",
              display: "block",
              borderRadius: "15px",
              border: "6px solid rgba(143, 188, 143, 0.3)",
            }}
          />
        </div>
      </div>

      <div
        className={styles.viewTextReverse}
        style={{
          fontSize: "12px",
          maxWidth: "500px",
          textAlign: "left"
        }}
      >
        <h2 className={styles.head} style={{ fontSize: "2.4em", marginBottom: "20px" }}>
         Always-On Business Continuity
        </h2>
        <p style={{ color: "black", fontSize: "1.5em" }}>Track all transactions, terminals, and staff performance with Arifpay's built-in analytics tools.</p>
        <p style={{ color: "black", fontSize: "1.5em" }}>
        Your business doesn’t stop and neither do we. Arifpay offers a stable, secure infrastructure for nonstop transactions and full device support.
        </p>
      </div>
    </div>
  </section>
</div>

      <section className={styles.buttonSection}>
        <div className={styles.buttonContainer}>
          <div className={styles.buttonText}>
            <p className={styles.subheading}>
              FASTER, SAFER, AND SMARTER SOLUTIONS
            </p>
            <h2 className={styles.buttonHeader}>Industry Specific Solutions</h2>
            <p className={styles.buttonParagraph}>
             Micro, small, and medium enterprises need agility and reliability to grow. Our smart payment solutions streamline sales, automate transactions, and provide secure processing giving MSMEs the tools to operate and scale with confidence.
            </p>
          </div>

          <div className={styles.buttonAndText}>
            <div className={styles.buttonGroup}>
              <div className={styles.mobileButtonSlider}>
                {[
                  "Payment in Store",
                  "Payment on the go",
                  "Self Service",
                  "Commerce Service",
                ].map((btn) => (
                  <button
                    key={btn}
                    className={`${styles.industryButton} ${
                      activeButton === btn ? styles.activeIndustryButton : ""
                    }`}
                    onClick={() => setActiveButton(btn)}
                    style={{
                      backgroundColor:
                        activeButton === btn ? "var(--primary-green)" : "",
                      color: activeButton === btn ? "white" : "",
                    }}
                  >
                    {btn} <span className={styles.buttonIcon}>→</span>
                  </button>
                ))}
              </div>
            </div>

            <div className={styles.mobileButtonContent}>
              {getContent(activeButton)}
            </div>
          </div>
        </div>
      </section>

      <section className={styles.bottom}>
        <div
          className={styles.bottom}
          style={{
            backgroundColor: "var(--primary-green)",
            color: "#fff",
            padding: "20px 30px",
            borderRadius: "35px",
            margin: "40px 70px 40px 50px",
          }}
        >
          <div
            style={{
              maxWidth: "1200px",
              margin: "0 auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            {/* Text Content */}
            <div style={{ flex: "1", maxWidth: "550px", marginBottom: "30px" }}>
              <h2
                style={{
                  fontSize: "2em",
                  marginBottom: "15px",
                  color: "white",
                }}
              >
                It Starts With Your Business
                <br />
                Account
              </h2>
              <p style={{ fontSize: "0.9em" }}>
                <span style={{ color: "white", fontSize: "0.6em" }}>✦</span>{" "}
                Join our merchants.
              </p>
              <Link to="/become-a-merchant">
                {" "}
                <button
                  className={styles.but}
                  style={{
                    backgroundColor: "#fff",
                    color: "green",
                    border: "none",
                    padding: "15px 30px",
                    borderRadius: "5px",
                    fontSize: "16px",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  Register Now →
                </button>
              </Link>
            </div>

            {/* Image Side */}
            <div
              style={{ flex: "1", display: "flex", justifyContent: "flex-end" }}
            >
              <img
                src={view}
                alt="Payment Terminal"
                style={{
                  width: "100%",
                  maxWidth: "450px",
                  height: "auto",
                  objectFit: "cover",
                  borderRadius: "25px",
                  border: "5px solid green",
                }}
              />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Msmes;
